module.exports = {"341272001":"阜阳开发区京九街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341272.json
// module id = 1235
// module chunks = 0